import { render, staticRenderFns } from "./HProduct.vue?vue&type=template&id=1cfb0009&scoped=true&"
import script from "./HProduct.vue?vue&type=script&lang=js&"
export * from "./HProduct.vue?vue&type=script&lang=js&"
import style0 from "./HProduct.vue?vue&type=style&index=0&id=1cfb0009&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cfb0009",
  null
  
)

export default component.exports